import { observer } from 'mobx-react';
import { useCallback } from 'react';
import classNames from 'classnames';
import NotificationsCount from '../../NotificationsCount/NotificationsCount';
import { localeStore } from '~/mobx/localesStore';
import './style.scss';
import shortNumber from '~/utils/shortNumber';

interface Props<T> {
  label: string;
  onPress: (value: T) => void;
  value: T;
  isActive?: boolean;
  count: number;
  color?: 'red' | 'blue';
}

export const TabLabel = observer((props: Props<string>) => {
  const onPress = useCallback(() => props.onPress(props.value), [props]);

  // const type = props.value === ORDERS_GROUPS.AHEAD ? ORDER_TYPE.AHEAD : ordersStore.filters.type;
  // const value = props.value === ORDERS_GROUPS.AHEAD ? 'new' : props.value;

  return (
    <button className={classNames('tab-label mr-3', { active: props.isActive })} onClick={onPress}>
      {localeStore.t(props.label)}
      <NotificationsCount count={shortNumber(props.count || 0, true)} color={props.color} />
    </button>
  );
});
